import styled, { css } from 'styled-components';

import { pxToRem } from 'utils/scss';

export const WidgetContainerWrapper = styled.div`
  height: ${props => (props.height ? `${pxToRem(props.height)}` : '100%')};
  width: 100%;
  background-color: ${props => props.theme.colors.white};
  border-radius: ${pxToRem('20px')};

  padding: ${pxToRem('16px')} ${pxToRem('24px')};

  &:hover {
    box-shadow: ${props =>
      props.noShadow
        ? ''
        : `0 ${pxToRem('52px')} ${pxToRem('32px')} -${pxToRem('21px')} ${
            props.theme.colors.black.five
          }`};
  }
`;
export const ChartContainer = styled.div`
  height: 80%;
`;
export const Title = styled.div`
  margin-bottom: ${pxToRem('16px')};
`;
export const SubTitle = styled.div`
  margin-bottom: ${props => props.subMargin}px;
  color: #919397;
  ${props =>
    props.tagLabel &&
    css`
      margin-left: ${pxToRem('24px')};
    `}
`;
